import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicLaplaceTransform = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="LAPLACE TRANSFORM: INTRODUCTION"
      videos={["https://www.youtube.com/embed/OA1OJrfpP20"]}
      takeaways={[
        
        { text: "Basic formulas" },
        {  image: "/lp_1.png"},
        {  image: "/lp_2.png"},
        {  image: "/lp_3.png"},
        {  image: "/lp_4.png"},
      ]} // No takeaways provided
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicLaplaceTransform;
